import React from 'react';
import ReactApexCharts from 'react-apexcharts';
import PropTypes from 'prop-types';
import { formatNumber } from 'helper';

function LineChart({ data, isLoading }) {
  const options = {
    stroke: {
      curve: 'smooth',
      lineCap: 'butt',
    },
    xaxis: {
      categories: data?.map((item, i) => item?.title ?? `Data ${i + 1}`),
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm',
      },
      y: {
        formatter(val) {
          if (!val) return '';
          return formatNumber(val, 0);
        },
      },
    },
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      formatter(val) {
        if (!val) return '';
        return formatNumber(val, 0);
      },
    },
    colors: ['#2486bc'],
  };

  const series = [
    {
      name: 'Total',
      data: data?.map((item) => item?.count ?? null),
    },
  ];
  if (isLoading) {
    return (
      <div className="h-full w-full pl-10 py-8 pr-6">
        <div
          className="animate-pulse bg-gray-50 h-full w-full rounded"
          style={{
            clipPath:
              'polygon(0 80%, 13% 71%, 25% 55%, 39% 44%, 54% 51%, 66% 46%, 78% 34%, 90% 22%, 100% 33%, 100% 43%, 100% 100%, 0% 100%)',
          }}
        />
      </div>
    );
  }
  return (
    <ReactApexCharts
      height="100%"
      options={options}
      series={series}
      type="area"
    />
  );
}
LineChart.defaultProps = {
  data: {
    labels: [],
    series: [],
  },
  isLoading: false,
};

LineChart.propTypes = {
  data: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool,
};

export default LineChart;
